import { Box, Text, Breadcrumbs, Anchor, Group } from '@mantine/core'
import { useNavigate } from 'react-router-dom'

interface BreadcrumbItem {
  label: string
  path?: string
}

interface PageHeaderProps {
  title: string
  subtitle?: string
  breadcrumbs: BreadcrumbItem[]
  actions?: React.ReactNode
  isMobile?: boolean
}

export function PageHeader({ title, subtitle, breadcrumbs, actions, isMobile }: PageHeaderProps) {
  const navigate = useNavigate()

  const hasBreadcrumbs = breadcrumbs.length > 1
  // `title` entra na condicao: a prop era declarada e nunca desestruturada — aceita e
  // ignorada — e sem incluir aqui a rota de um nivel so continuaria sem cabecalho, que e
  // exatamente onde este passo mais faz diferenca.
  if (!hasBreadcrumbs && !subtitle && !actions && !title) return null

  return (
    <Box
      style={{
        backgroundColor: 'var(--ai-body-bg)',
        padding: isMobile ? '8px 12px 0' : '12px 30px 0',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexShrink: 0,
        minWidth: 0,
        overflow: 'hidden',
      }}
    >
      <Box style={{ minWidth: 0, overflow: 'hidden', flex: 1 }}>
        {/* Em mobile, exibir só o breadcrumb (sem subtitle) para economizar espaço */}
        {hasBreadcrumbs && !isMobile && (
          <Breadcrumbs
            separator="/"
            styles={{
              // Trilha e navegacao: como a pessoa volta. DS 11.1 mede muted em 2,8:1 e
              // o marca "apenas decorativo"; DS 11.2 poe o piso do essencial em secondary.
              separator: { color: 'var(--ai-text-secondary)', fontSize: 11 },
              breadcrumb: { fontSize: 12 },
            }}
          >
            {breadcrumbs.map((item, i) =>
              item.path && i < breadcrumbs.length - 1 ? (
                <Anchor
                  key={i}
                  size="xs"
                  c="var(--ai-text-secondary)"
                  onClick={(e) => { e.preventDefault(); navigate(item.path!) }}
                  style={{ cursor: 'pointer', textDecoration: 'none' }}
                >
                  {item.label}
                </Anchor>
              ) : (
                <Text key={i} size="xs" c="var(--ai-text-secondary)" fw={600}>
                  {item.label}
                </Text>
              ),
            )}
          </Breadcrumbs>
        )}
        {/* O titulo passa a vir daqui. Antes, 4 paginas desenhavam o seu, e "Banco de Dados"
            aparecia tres vezes empilhado: barra do topo, trilha e titulo da pagina. */}
        {title && (
          <Text
            size="xl"
            fw={700}
            style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {title}
          </Text>
        )}
        {/* Descricao junto do titulo, sem travessao — o travessao existia so para separa-la
            da trilha. E em --ai-text-secondary: DS 11.1 mede muted em 2,8:1 e o marca
            "apenas decorativo"; DS 11.2 poe o piso do texto essencial em secondary. */}
        {subtitle && !isMobile && (
          <Text size="xs" c="var(--ai-text-secondary)">{subtitle}</Text>
        )}
      </Box>

      {actions && (
        <Group gap="md" style={{ flexShrink: 0 }}>
          {actions}
        </Group>
      )}
    </Box>
  )
}
